import React, {useState, useEffect} from "react";
import {useParams, Link, useNavigate} from 'react-router-dom';
import {
	getProjects,
	getProjectAncestry,
	deleteProject
} from "./apiService";

const cloneProject = (project, projectId, callback) => {
	console.log('cloneProject', project, projectId);
	let newProject = {
		id: project.id,
		code: project.code
	};
	if(project.id === projectId) {
		console.log('cloneProject execute callback', projectId);
		callback(newProject);
	}
	else if(project.children) {
		newProject.children = cloneProjects(project.children, projectId, callback);
	}
	return newProject;
};

const cloneProjects = (projects, projectId, callback) => {
	let newProjects = {};
	for(let key of Object.getOwnPropertyNames(projects)) {
		newProjects[key] = cloneProject(projects[key], projectId, callback);
	}
	return newProjects;
};

const Projects = (props) => {
	const [error, setError] = useState(null);
	const [isLoaded, setIsLoaded] = useState(false);
	const [projects, setProjects] = useState({});
	const navigate = useNavigate();
	const params = useParams();

	useEffect(() => {
		console.log('Projects useEffect', params);
		let projectIdParam = params.projectId;
		getProjects().then(
			data => {
				console.log('Projects getProjects data', data);
				setIsLoaded(true);
				let projectsObj = {};
				for(let project of data) {
					projectsObj[project.id] = project;
				}
				if(projectIdParam != null) {
					getProjectAncestry(projectIdParam).then(
						data => {
							if(data.status === 401) {
								navigate('/login', {replace: true});
								return;
							}
							if(data.status !== 200) {
								setError(data);
								return;
							}
							let ancestry = data.result;
							let expand = (index) => {
								if(index >= ancestry.length) {
									setProjects(projectsObj);
									return;
								}
								let projectId = ancestry[index];
								getProjects(projectId).then(
									data => {
										console.log('expand getProjects data', data);
										projectsObj = cloneProjects(projectsObj, projectId, newProject => {
											console.log('expand callback', data);
											newProject.children = {};
											for(let project of data) {
												newProject.children[project.id] = project;
											}
										});
										expand(index + 1);
									},
									error => {
										console.error('error object', error);
										setError(error);
									}
								);
							};
							expand(0);
						},
						error => {
							console.error('error object', error);
							setError(error);
						}
					);
				}
				else {
					setProjects(projectsObj);
				}
			},
			error => {
				if(error.status === 401) {
					window.localStorage.removeItem('token');
					navigate('/login', {replace: true});
					return;
				}
				console.error('error object', error);
				setIsLoaded(true);
				setError(error);
			}
		);
	}, [navigate, params]);

	if(error) {
		return <div>Error: {error.message}</div>;
	}

	if(!isLoaded) {
		return <div>Loading...</div>;
	}

	console.log('Projects render', projects);

	const expand = projectId => {
		console.log('expand', projectId);
		getProjects(projectId).then(
			data => {
				console.log('expand getProjects data', data);
				setProjects(cloneProjects(projects, projectId, newProject => {
					console.log('expand callback', data);
					newProject.children = {};
					for(let project of data) {
						newProject.children[project.id] = project;
					}
				}));
				// https://developer.mozilla.org/en-US/docs/Web/API/History/pushState
				// history.pushState({}, '', '');
			},
			error => {
				console.error('error object', error);
				setError(error);
			}
		);
	};

	const contract = projectId => {
		console.log('contract', projectId);
		setProjects(cloneProjects(projects, projectId, newProject => {
			delete newProject.children;
		}));
	};

	const handleDeleteProject = projectId => {
		console.log('handleDeleteProject', projectId);
		deleteProject(projectId).then(
			data => {
				console.log('deleteProject data', data);
				setProjects(cloneProjects(projects, projectId, newProject => {
					delete newProject.children;
					newProject.deleted = true;
				}));
			},
			error => {
				console.error('error object', error);
				setError(error);
			}
		);
	};

	let projectsArray = [];

	const populateProjectsArray = (projects, level) => {
		let children = [];
		for(let projectId in projects) {
			let project = projects[projectId];
			if(!project.deleted) {
				children.push(project);
			}
		}
		children.sort((p1, p2) => {
			let code1 = p1.code.toLowerCase();
			let code2 = p2.code.toLowerCase();
			if(code1 < code2) {
				return -1;
			}
			if(code1 > code2) {
				return 1;
			}
			return 0;
		});
		for(let project of children) {
			project.level = level;
			projectsArray.push(project);
			if(project.children) {
				project.expanded = true;
				populateProjectsArray(project.children, level + 1);
			}
			else {
				project.expanded = false;
			}
		}
	};

	populateProjectsArray(projects, 0);
	console.log('projectsArray', projectsArray);

	return (
		<>
		<div class="header">Projects &nbsp;
			<Link to={`/project`}>Add</Link>
		</div>
		<table className={'projects'}>
		<tbody>
		{
			projectsArray.map(project => {
				return (
					<tr key={project.id}>
						<td style={{paddingLeft: `${project.level * 20}px`}}>
							{project.expanded ? (
								<span className={'button'} style={{cursor: 'pointer'}} onClick={e => {
									contract(project.id);
								}}>-</span>
							) : (
								<span className={'button'} style={{cursor: 'pointer'}} onClick={e => {
									expand(project.id);
								}}>+</span>
							)}
							&nbsp; <Link to={`/project/${project.id}`}>{project.code}</Link>
						</td>
						<td>
							<button type="button" onClick={
								e => {
									handleDeleteProject(project.id);
								}
							}>Delete</button>
						</td>
					</tr>
				);
			})
		}
		</tbody>
		</table>
		</>
	);
};

export default Projects;